/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import { AdWaypointPassengersWaypointFragmentDoc } from '../../../../ad-passenger-list/src/lib/AdWaypointPassengers/AdWaypointPassengers.hook'
import {
  BaseAlertCardAdAlertFragmentDoc,
  BaseAlertCardVehicleFragmentDoc,
} from '../../../../alert-cards-common/src/lib/BaseAlertCard/BaseAlertCard.hook'
import { VehicleIconLinkVehicleFragmentDoc } from '../../../../alert-cards-common/src/lib/VehicleIconLink/vehicleIconLink.hook'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type ManualNoShowRequestedAdAlertCardFragment = {
  __typename: 'FccAdAlert'
  id: string
  status: Types.FccAdAlertStatus
  type: Types.FccAdAlertType
  vehicle: {
    __typename?: 'Vehicle'
    totalPassengersInVehicle: number | null
    id: string
    inService: boolean | null
    label: number | null
    isSelfDriving: boolean
    fccUpcomingWaypoints: Array<{
      __typename?: 'FccWaypoint'
      id: string
      stop: {
        __typename?: 'Stop'
        id: string
        names: Partial<Record<'de' | 'en', string>>
        serviceArea: { __typename?: 'ServiceArea'; id: string }
      } | null
      actions: Array<
        | {
            __typename: 'FccWaypointDeliveryAction'
            id: string
            estimatedAt: string
            pickedUpAt: string | null
            trip: { __typename?: 'Trip'; id: string } | null
            customer: {
              __typename?: 'Customer'
              firstName: string | null
              lastName: string | null
              extendedWalkingTime: boolean
              visualImpairment: boolean | null
            } | null
            seats: {
              __typename?: 'FccWaypointSeatInfo'
              seats: number
              wheelchairs: number
              childSeats: number
              boosterSeats: number
            }
          }
        | { __typename?: 'FccWaypointHubReturnAction' }
        | {
            __typename: 'FccWaypointPickupAction'
            id: string
            estimatedAt: string
            pickedUpAt: string | null
            adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
            notShownUpAt: string | null
            tripIsCancelled: boolean | null
            trip: { __typename?: 'Trip'; id: string } | null
            customer: {
              __typename?: 'Customer'
              firstName: string | null
              lastName: string | null
              extendedWalkingTime: boolean
              visualImpairment: boolean | null
            } | null
            seats: {
              __typename?: 'FccWaypointSeatInfo'
              seats: number
              wheelchairs: number
              childSeats: number
              boosterSeats: number
            }
          }
        | { __typename?: 'FccWaypointReallocationAction' }
      >
    }> | null
  } | null
  assignee: {
    __typename?: 'BackofficeUser'
    id: string
    username: string
  } | null
  statusChanges: Array<{
    __typename: 'FccAdAlertStatusChange'
    bySystem: boolean
    date: string
    to: Types.FccAdAlertStatus
    byUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export const ManualNoShowRequestedAdAlertCardFragmentDoc = gql`
    fragment ManualNoShowRequestedAdAlertCard on FccAdAlert {
  id
  ...BaseAlertCardAdAlert
  vehicle {
    totalPassengersInVehicle
    ...VehicleIconLinkVehicle
    ...BaseAlertCardVehicle
    fccUpcomingWaypoints {
      ...AdWaypointPassengersWaypoint
    }
  }
}
    ${BaseAlertCardAdAlertFragmentDoc}
${VehicleIconLinkVehicleFragmentDoc}
${BaseAlertCardVehicleFragmentDoc}
${AdWaypointPassengersWaypointFragmentDoc}`
